import { Piaoduoduomixer } from '@linktivity/eticketportal';

type GetRailwayInfoRequest = Piaoduoduomixer.GetBookingInfoRequest;
type GetRailwayInfoResponse = Piaoduoduomixer.GetBookingInfoResponse;
type RailwayOrderStatus = Piaoduoduomixer.GetBookingInfoResponseStatus;
const RailwayOrderStatus = Piaoduoduomixer.GetBookingInfoResponseStatus;
type GetBookingInfoLanguageCodeEnum =
  Piaoduoduomixer.GetBookingInfoLanguageCodeEnum;
const GetBookingInfoLanguageCodeEnum =
  Piaoduoduomixer.GetBookingInfoLanguageCodeEnum;
type OrderTicketRequest = Piaoduoduomixer.OrderRequest;
type OrderableTimeRange = Piaoduoduomixer.OrderableTimeRange;
type GetTrainListRequest = Piaoduoduomixer.GetAvailableTrainsRequest;
type QA = Piaoduoduomixer.QA;
type RailwayTrainInfo = Piaoduoduomixer.TrainInfo;

type CancelIssuingOrderRequest = Piaoduoduomixer.CancelIssuingOrderRequest;
type DateOption = {
  value: string;
  label: string;
  weekday: string;
};

/**
 * Seat class 9商务座; P 特等座; M 一等座; O 二等座
 */
enum SeatClass {
  Business = '9',
  Premium = 'P',
  First = 'M',
  Second = 'O'
}

type SeatClassType = (typeof SeatClass)[keyof typeof SeatClass];

export type {
  GetRailwayInfoRequest,
  GetRailwayInfoResponse,
  OrderableTimeRange,
  GetTrainListRequest,
  RailwayTrainInfo,
  DateOption,
  SeatClassType,
  OrderTicketRequest,
  QA,
  CancelIssuingOrderRequest
};

export { RailwayOrderStatus, GetBookingInfoLanguageCodeEnum, SeatClass };
